import { CREATE_AND_BIND_TEMPLATE, CREATE_TEMPLATE, HIDE_PLAY_QUEUE, SHOW_PLAY_QUEUE, TOGGLE_PLAY_QUEUE, } from '../actions';
export const initialState = {
    isPlayQueueOpen: false,
};
export function PlayQueueReducer(state = initialState, action) {
    switch (action.type) {
        case SHOW_PLAY_QUEUE:
            return {
                isPlayQueueOpen: true,
            };
        case TOGGLE_PLAY_QUEUE:
            return {
                isPlayQueueOpen: !state.isPlayQueueOpen,
            };
        case HIDE_PLAY_QUEUE:
            return {
                isPlayQueueOpen: false,
            };
        case CREATE_TEMPLATE:
        case CREATE_AND_BIND_TEMPLATE:
            return {
                isPlayQueueOpen: false,
            };
        default:
            return state;
    }
}
